/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationForFinOpsConsolidatedReport extends models.ConfigurationForNextGenReportBase {
    constructor() {
        super();
        this.setDiscriminator("ConfigurationForFinOpsConsolidatedReport");
    }

    getFixupPrototypeFunction() { return ConfigurationForFinOpsConsolidatedReport.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationForFinOpsConsolidatedReport>): ConfigurationForFinOpsConsolidatedReport {
        let obj = Object.assign(new ConfigurationForFinOpsConsolidatedReport(), model);
        ConfigurationForFinOpsConsolidatedReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationForFinOpsConsolidatedReport>): ConfigurationForFinOpsConsolidatedReport {
        if (!model) return null;
        return ConfigurationForFinOpsConsolidatedReport.newInstance(<ConfigurationForFinOpsConsolidatedReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationForFinOpsConsolidatedReport) {
        if (!obj) return;

        models.ConfigurationForFinOpsConsolidatedReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationForFinOpsConsolidatedReport): boolean {
        if (models.ConfigurationForNextGenReportBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ConfigurationForFinOpsConsolidatedReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
        if (this.time_range) {
            models.RangeSelection.fixupPrototype(this.time_range);
        }
        if (this.group_by) {
            for (let val of this.group_by) {
                models.BillingGroupByDetails.fixupPrototype(val);
            }
        }
        if (this.group_by_terminology) {
            for (let val of this.group_by_terminology) {
                models.GroupByTerminology.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account IDs
     */
    service_account_ids: Array<string>;

    /**
     * Granularity to aggregate data
     */
    granularity: models.TrendGranularity;

    /**
     * Billing source to select data from
     */
    billing_source: string;

    /**
     * If set, the dimensions to group results by
     */
    group_by: Array<models.BillingGroupByDetails>;

    /**
     * Client-supplied terminology for each group-by dimension in use
     */
    group_by_terminology: Array<models.GroupByTerminology>;

    /**
     * Query expression to filter line items
     */
    filters: models.QueryOperator;

    time_range: models.RangeSelection;

    /**
     * Use organization currency rules to convert to the configured currency
     */
    use_organization_currency: boolean;

    /**
     * Include charge descriptions in the report.
     */
    include_charge_description: boolean;

    /**
     * Include usage quantity and rate details in the report.
     */
    include_usage_and_rate: boolean;

}
